import fetch from "@lib/fetch";
import type { Queries } from "@lib/serializeQueryObjects";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalWorkflows } from "./constants";
import type { ConversationalWorkflowsParams, ConversationalWorkflowsResult } from "./types";
import { isConversationalWorkflowsResult } from "./validators";

export const getDataTableConversationalWorkflows = reactQueryTableFetcherAdapter(
  conversationalWorkflows,
  (
    signal: AbortSignal,
    { appGroupId, query = {}, groupby, limit = 20, start = 0, sortdir, sortby }: ConversationalWorkflowsParams
  ): Promise<ConversationalWorkflowsResult> => {
    return fetch(
      `/${appGroupId}/conversational/workflows`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query as Queries),
      },
      { signal }
    );
  },
  isConversationalWorkflowsResult
);
